import React, { useEffect, useRef, useState } from "react";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";

import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid
} from "@material-ui/data-grid";
import { Delete } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import MessageIcon from "@material-ui/icons/Message";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import CustomAlert from "components/CustomAlert/CustomAlert";
import Button from "components/CustomButtons/Button.js";
import CustomModal from "components/CustomModal/CustomModal";
import GridContainer from "components/Grid/GridContainer.js";
import useDeleteNotification from "hooks/notificationHooks/useAppDeleteNotification";
import useUpdateNotification from "hooks/notificationHooks/useUpdateNotification";
import SweetAlert from "react-bootstrap-sweetalert";
import notificationService from "services/notificationService";
import AppNotifications from "views/Forms/AppNotifications";
import EventSchedule from "views/Forms/EventSchedule";
// const useStyles = makeStyles(styles);
var styles = {
  ...tablestyles,
  ...sweetAlertStyle,
};
const useStyles = makeStyles(styles);

export default function AppNotificationListing(props) {
  // const {
  //   data: notifications,
  //   error: notificationsFetchError,
  //   isLoading: notificationsFetchLoading,
  // } = useGetAllNotifications();

  const updateNotification = useUpdateNotification();
  const deleteNotification = useDeleteNotification();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  console.log(rows);
  const [notificationsEditForm, setNotificationsEditForm] = React.useState(
    null
  );

  const [deleteModal, setDeleteModal] = React.useState(null);

  const ref = useRef(null);

  const classes = useStyles();
  const [refresh, setRefresh] = React.useState(0);
  const refreshDashboard = () => {
    setRefresh(refresh + 1);
  };
  const showDeleteConfirmation = (id) => {
    setDeleteModal(
      <SweetAlert
        showCancel
        confirmBtnText="Yes"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        title=""
        onConfirm={async () => {
          try {
            await deleteNotification.mutateAsync(id);
            hideDeleteCustomModal();
            fetchNotifications(); // refresh grid
          } catch (error) {
            console.log(error);
          }
        }}
        onCancel={() => {
          hideDeleteCustomModal();
        }}
        focusCancelBtn
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.warning}
      >
        Are you sure you want to delete this notification?
      </SweetAlert>

    );
  };

  const hideDeleteCustomModal = () => {
    setDeleteModal(null);
  };

  const onDelete = async (e, id) => {
    showDeleteConfirmation(id);
  };

  const onUpdate = (e, values) => {
    e.preventDefault();

    updateNotification.mutate(values.row);
  };

  const onInfo = (e, id) => {
    alert("info");
  };

  const handleRowSelection = (e) => {
    // setSelection(e);
    console.log(e);
  };

  const onCellEditCommit = (p) => { };

  const onCellBlur = (e, p) => { };

  const handleEdit = (p, e) => { };

  React.useEffect(() => {
    let cols = [
      {
        field: "title",
        headerName: "Title",
        editable: false,
        width: 260,
      },
      {
        field: "summary",
        headerName: "Summary",
        editable: false,
        width: 220,
      },
      {
        field: "tag",
        headerName: "Tag",
        editable: false,
        width: 220,
      },
      {
        field: "readTime",
        headerName: "Read Time",
        editable: false,
        width: 220,
      },
      {
        field: "sendDate",
        headerName: "Send Date",
        editable: false,
        width: 220,
        renderCell: (params) => formatDate(params.value),
      },
      {
        field: "isPublished",
        headerName: "Status",
        editable: false,
        width: 220,
        renderCell: (params) => (params.value ? "Published" : "Scheduled / Draft"),
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 150,
        renderCell: (params) => (
          <>
            <Button
              color="rose"
              size="sm"
              onClick={() => createNotificationsEditForm(params?.row?.globalNotificationId, "Edit Notifications", params?.row?.images["$values"], params?.row?.isPublished)}
              style={{ textTransform: "none" }}
              justIcon
              round
            >
              <EditIcon />
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={() =>
                onDelete(null, params?.row?.globalNotificationId)
              }
              style={{ textTransform: "none" }}
              justIcon
              round
            >
              <Delete />
            </Button>
          </>
        ),
      },

    ];
    setColumns(cols);
  }, []);
  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  // function formatDate(date) {
  //   const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
  //   let a = localDate.getHours() >= 12 ? "PM" : "AM";
  //   let hours = localDate.getHours();
  //   hours = hours % 12;
  //   hours = String(hours ? hours : 12).padStart(2, '0');
  //   console.log(a);
  //   return (
  //     [
  //       padTo2Digits(localDate.getDate()),
  //       padTo2Digits(localDate.getMonth() + 1),
  //       localDate.getFullYear(),
  //     ].join("/") +
  //     " " +
  //     [
  //       padTo2Digits(hours),
  //       padTo2Digits(localDate.getMinutes()),
  //       padTo2Digits(localDate.getSeconds()),
  //       padTo2Digits(a),
  //       // padTo2Digits(date.getSeconds()),
  //     ].join(":")
  //   );
  // }

  function formatDate(dateString) {
    if (!dateString) return "";

    // If the API date has no timezone, treat it as UTC by appending Z
    let safeString = dateString;
    if (!/[Zz]|[+\-]\d{2}:\d{2}$/.test(dateString)) {
      safeString = dateString + "Z";
    }

    const date = new Date(safeString);

    return new Intl.DateTimeFormat("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    })
      .format(date)
      .replace(",", "") // remove comma
      .replace(/\s(am|pm)$/i, (m, p) => " " + p.toUpperCase()); // AM/PM uppercase
  }



  // React.useEffect(() => {
  //   if (notifications) {
  //     setRows(
  //       notifications["$values"].map((x, i) => {
  //         console.log(x);
  //         return {
  //           ...x,
  //           id: i,
  //           sendDateTime: formatDate(new Date(x.sendDateTime)),
  //           tempsendate: x.sendDateTime,
  //           createdDate: formatDate(new Date(x.createdDate)),
  //         };
  //       })
  //     );
  //   }
  // }, [notifications, refresh]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      const res = await notificationService.getAll(page + 1, pageSize, false);

      // Expected API shape:
      // res.data.$values  → data list
      // res.totalCount     → total rows

      if (res?.$values) {
        const formattedRows = res.$values.map((x, index) => ({
          ...x,
          id: index + page * pageSize,
          sendDateTime: formatDate(x.sendDate),
          tempsendate: x.sendDate,
        }));

        setRows(formattedRows);
      }

      if (res.$values[0].totalCount) {
        setRowCount(res.$values[0].totalCount);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page, pageSize, notificationsEditForm]);

  const createNotificationsEditForm = (notificationId, title, images = [], isPublished) => {
    console.log('passedidis', notificationId);
    setNotificationsEditForm(
      <CustomModal
        modal={true}
        setModal={() => hideNotificationsEditForm()}
        content={
          <AppNotifications
            icon={PersonAddIcon}
            // notification={row}
            afterFinish={() => hideNotificationsEditForm()}
            noti={notificationId}
            images={images}
            isPublished={isPublished}
          />
        }
        cancelButtonMessage="cancel"
        okButtonMessage="Create"
        showOk={false}
        onCancelClick={() => hideNotificationsEditForm()}
        title={<h5>{notificationId ? "Edit Message" : "New Message"}</h5>}
        maxWidth="lg"
        fullWidth={true}
      />
    );
  };
  const createScheduleEvent = (title) => {
    // console.log(notificationId);
    setNotificationsEditForm(
      <CustomModal
        modal={true}
        setModal={() => hideNotificationsEditForm()}
        content={
          <EventSchedule
            icon={PersonAddIcon}
            // notification={row}
            afterFinish={() => hideNotificationsEditForm()}
          // noti={notificationId}
          />
        }
        cancelButtonMessage="cancel"
        okButtonMessage="Create"
        showOk={false}
        onCancelClick={() => hideNotificationsEditForm()}
        title={<h5>Add Schedule Event</h5>}
        maxWidth="lg"
        fullWidth={true}
      />
    );
  };


  const hideNotificationsEditForm = () => {
    setNotificationsEditForm(null);
  };

  const getRowClassName = (row) => {
    return null;
  };
  const [filterModel, setFilterModel] = React
    .useState
    // {
    // items: [
    //   { id: 1, columnField: 'title', operatorValue: 'contains', value: null  },
    //   // { id: 2, columnField: 'board', operatorValue: 'contains', value: null  },
    //   // { id: 2, columnField: 'state', operatorValue: 'contains', value: null  },
    // ],
    // // linkOperator: GridLinkOperator.And,
    // }
    ();
  const onhandlechange = (e) => {
    console.log(e);
    setFilterModel(e);
  };
  // function CustomToolbar() {
  //   return (
  //     <GridContainer spacing={4}>
  //       <GridItem>
  //         <CustomInput
  //           formControlProps={{
  //             fullWidth: true,
  //           }}
  //           required={true}
  //           inputProps={{
  //             // name: "title",
  //             // id: 1, columnField: 'title', operatorValue: 'contains', value: null ,
  //             onChange:(e)=> setFilterModel(e),
  //             value:filterModel.items[0]{id: 1, columnField: 'title', operatorValue: 'contains', value: null }
  //           }}
  //         />
  //       </GridItem>
  //       <GridItem>
  //         <CustomInput variant="outlined" />
  //       </GridItem>
  //       <CustomInput variant="outlined" />
  //       {/* <CustomInput variant="outlined"/>
  //     <GridToolbarFilterButton/>
  //     <GridToolbarExport /> */}
  //     </GridContainer>
  //   );
  // }

  return (
    <Card>
      <CardHeader color="rose" icon>
        <CardIcon color="rose">
          <MessageIcon />
        </CardIcon>
      </CardHeader>
      <CardBody>
        <GridContainer justifyContent="flex-end">
          {/* <Button
            color="rose"
            onClick={() => {
              refreshDashboard();
              //getQ();
            }}
            style={{
              textTransform: "none",
              marginLeft: 20,
              // width: 190,
              alignItems: "flex-end",
            }}
          >
            <RefreshIcon /> Refresh
          </Button> */}
          &nbsp;
          &nbsp;
          &nbsp;
          <Button
            color="rose"
            onClick={() => {
              createNotificationsEditForm(null, "New Notifications");
              //getQ();
            }}
            style={{
              textTransform: "none",
              // marginLeft: 170,
              // width: 190,
              marginBottom: 21,
              marginTop: 20,
              alignItems: "flex-end",
            }}
          // style={{textTransform: "none"}}
          >
            + Add
          </Button>
          {/* <Button
            color="rose"
            onClick={() => {
              createScheduleEvent("Schedule Event");
              //getQ();
            }}
            style={{
              textTransform: "none",
              // marginLeft: 170,
              width: 190,
              alignItems: "flex-end",
            }}
            // style={{textTransform: "none"}}
          >
            + Schedule Event
          </Button>
         */}
          <div style={{ height: 500, width: "100%" }}>
            <div style={{ display: "flex", height: "100%" }}>
              {rows ? (
                <div ref={ref} style={{ flexGrow: 1 }}>
                  {/* <DataGrid
                    columns={columns}
                    rows={rows}
                    // components={{
                    //   Toolbar: CustomToolbar,
                    // }}
                    filterModel={filterModel}
                    // GridFilterModel={(e)=>{onhandlechange(e)}}
                    onFilterModelChange={(model) => {
                      onhandlechange(model);
                    }}
                    autoPageSize={true}
                    onEditCellPropsChange={handleEdit}
                    onCellEditCommit={onCellEditCommit}
                    onSelectionModelChange={handleRowSelection}
                    getRowClassName={getRowClassName}
                    onCellBlur={onCellBlur}
                  /> */}
                  <DataGrid
                    ref={ref}
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    pagination
                    paginationMode="server"
                    rowCount={rowCount}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newSize) => {
                      setPageSize(newSize);
                      setPage(0);
                    }}
                  />
                </div>
              ) : (
                <div style={{ flexGrow: 1 }}>
                  <CircularProgress /> Loading notifications...
                </div>
              )}
            </div>
          </div>
        </GridContainer>
      </CardBody>
      {updateNotification.isError == true && (
        <CustomAlert
          open={true}
          severity="error"
          alertMessage="Error while updating Notification"
        />
      )}
      {updateNotification.isSuccess == true && (
        <CustomAlert
          open={true}
          severity="success"
          alertMessage="Notification Updated successfully"
        />
      )}
      {deleteNotification.isSuccess == true && (
        <CustomAlert
          open={true}
          severity="success"
          alertMessage="Notification Deleted successfully"
        />
      )}
      {notificationsEditForm}
      {deleteModal}
    </Card>
  );
}
